import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { SearchHotelComponent } from 'src/app/components/search-hotel/search-hotel.component';
import * as moment from 'moment';
import { BlocksService } from 'src/app/api/report/blocks.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { SearchAgenciesComponent } from 'src/app/components/search-agencies/search-agencies.component';
import SwalAlert from 'src/app/utils/swalalert';
declare var $: any;

@Component({
  selector: 'app-blocksagency-form',
  templateUrl: './blocksagency-form.component.html',
  styleUrls: ['./blocksagency-form.component.css']
})
export class BlocksagencyFormComponent implements OnInit {
  @ViewChild(SearchAgenciesComponent) SearchAgenciesComponent: any;

  private thisComponent: BlocksagencyFormComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  agencySelected: any = null;
  receiveds: any = [];
  transfers: any = [];

  // TOTALES TRASPASOS
  total_transfers: any = 0;
  total_delegated_payment: any = 0;

  // TOTALES RECIBIDOS
  total_receiveds = 0;
  total_assigned_payment = 0;

  transfers_selecteds: any = [];
  receiveds_selecteds: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private blocksService: BlocksService,
    private route: ActivatedRoute,
    public toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService,
    private alert: SwalAlert
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      agency_id: [null, [Validators.required]],
      date_start: [null],
      date_end: [null],
      previous_balance: [0],
      total_charged: [0],
      total_amortized: [0],
      observation: [null],
      is_all: [false],
      balance_transfers: [null],
      balance_receiveds: [null]
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.SearchAgenciesComponent.focused();
    }, 250);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  listBookings() {
    let val_params = 'agency_id=' + this.agencySelected.id;
    this.blocksService.blocksAgencySummary(val_params).subscribe({
      next: (data: any) => {
        this.transfers = data.transfers;
        this.receiveds = data.receiveds;
      }
    });
  }

  selectedAgenciesSearch(item_: any) {
    this.agencySelected = item_;
    this.item.patchValue({
      agency_id: this.agencySelected.id
    });
    this.listBookings();
  }

  removeAgencies() {
    this.agencySelected = null;
    this.item.patchValue({
      agency_id: null
    });
    setTimeout(() => {
      this.SearchAgenciesComponent.focused();
    }, 150);
    this.clearData();
  }

  clearData() {
    this.receiveds = [];
    this.transfers = [];
    this.transfers_selecteds = [];
    this.receiveds_selecteds = [];
    this.total_transfers = 0;
    this.total_delegated_payment = 0;
    this.total_receiveds = 0;
    this.total_assigned_payment = 0;
  }

  selectedAllBooking() {}

  selectedTransfers(booking: any) {
    let validate_ = this.toolsService.notExistObjInArr(
      booking,
      this.transfers_selecteds
    );
    if (validate_) {
      this.transfers_selecteds.push(booking);
    } else {
      let index = this.transfers_selecteds.indexOf(booking);
      this.transfers_selecteds.splice(index, 1);
    }
    this.calculateBalance();
  }

  selectedReceiveds(booking: any) {
    let validate_ = this.toolsService.notExistObjInArr(
      booking,
      this.receiveds_selecteds
    );
    if (validate_) {
      this.receiveds_selecteds.push(booking);
    } else {
      let index = this.receiveds_selecteds.indexOf(booking);
      this.receiveds_selecteds.splice(index, 1);
    }
    this.calculateBalance();
  }

  calculateBalance() {
    // transfers total
    this.total_transfers = 0;
    this.total_delegated_payment = 0;
    for (let i in this.transfers_selecteds) {
      let item = this.transfers_selecteds[i];
      this.total_transfers =
        this.total_transfers + Number(item.price_corporate * item.quantity);
      this.total_delegated_payment =
        this.total_delegated_payment + Number(item.delegated_payment);
    }

    // receiveds total
    this.total_receiveds = 0;
    this.total_assigned_payment = 0;
    for (let i in this.receiveds_selecteds) {
      let item = this.receiveds_selecteds[i];
      this.total_receiveds =
        this.total_receiveds + Number(item.price_corporate * item.quantity);
      this.total_assigned_payment =
        this.total_assigned_payment + Number(item.assigned_payment);
    }

    this.item.patchValue({
      balance_transfers: this.total_transfers - this.total_delegated_payment,
      balance_receiveds: this.total_receiveds - this.total_assigned_payment
    });
  }

  preSave() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let options = {
        title: '¡Atención!',
        message:
          '¿Esta seguro(a) de guardar el cuadre de la agencia ' +
          this.agencySelected.tradename +
          ' ?',
        cancel: 'Cancelar',
        confirm: 'Sí, GUARDAR DATOS!'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    let data: any = {};
    data.item = this.item.value;
    data.bookings_transfers = this.transfers_selecteds;
    data.bookings_receiveds = this.receiveds_selecteds;

    if (this.isEdit) {
      // this.brandService.update(this.checkId, this.item.value).subscribe({
      //   next: (data: any) => {
      //     this.alertifyMsg.success('Registro actualizado con éxito');
      //     this.cancel();
      //   }
      // });
    } else {
      this.blocksService.blocksAgencySave(data).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success('Registro realizado con éxito');
          this.cancel();
        }
      });
    }
  }

  validate() {
    if (this.agencySelected == null) {
      this.alertifyMsg.warning(
        'Debe seleccionar la agencia para cargar los datos'
      );
      return false;
    } else {
      if (this.transfers_selecteds.length == 0) {
        if (this.receiveds_selecteds.length == 0) {
          this.alertifyMsg.warning(
            'Se debe seleccionar al menos un registro para guardar los datos'
          );
          return false;
        }
      }
      if (this.receiveds_selecteds.length == 0) {
        if (this.transfers_selecteds.length == 0) {
          this.alertifyMsg.warning(
            'Se debe seleccionar al menos un registro para guardar los datos'
          );
          return false;
        }
      }
    }
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/cuadresagencia/lista'
    ]);
  }
}
